import React from 'react'
import styled from 'styled-components'
import { color } from 'styles/colors'
import { NoData } from 'styles/shared'

export function renderWarrantyStatus (policyStatus?: string | null, hasError?: boolean): JSX.Element {
  if (hasError) {
    return <S.Error>Error</S.Error>
  }

  switch (policyStatus?.toLowerCase() || null) {
    case 'active':
      return <S.Active>Active</S.Active>
    case null:
      return <S.NotFound>Not Found</S.NotFound>
    default:
      return <span>Expired</span>
  }
}

export const S = {
  Error: styled.span`
    color: ${color('noDataText')};
  `,
  Active: styled.span`
    color: ${color('positiveStatus')};
    font-weight: bold;
  `,
  NotFound: styled.span`
    color: ${color('noDataText')};
  `,
  NoData: styled(NoData)`
    h1 {
      font-size: 24px;
    }
  `
}
